import { convertHtmlToReact } from '@hedgedoc/html-to-react';
import { forwardRef, memo, useMemo } from 'react';

import { AssetAction } from '../AssetCard';
import { StyledImageTemplateWrapper } from './SVGCard.style';

export interface SVGProps {
  numberOfPhotos: number;
  defs: string;
  content: string;
  width: number;
  height: number;
}

export interface SVGCardProps {
  title?: string;
  details?: unknown;
  onClick: (action: AssetAction) => void;
}

export const SVGCard = memo(
  forwardRef(function SVGCard(
    { title, details, onClick }: SVGCardProps,
    ref: React.Ref<HTMLDivElement>
  ) {
    const SVGDetails = details as SVGProps;

    const defs = useMemo(() => SVGDetails?.defs || '', [SVGDetails?.defs]);
    const content = useMemo(() => SVGDetails?.content || '', [SVGDetails?.content]);

    return (
      <StyledImageTemplateWrapper
        onClick={() =>
          onClick({
            source: '',
            action: 'click',
            details: {
              name: title,
              numberOfPhotos: SVGDetails?.numberOfPhotos,
            },
          })
        }
        ref={ref}
      >
        {SVGDetails?.defs && SVGDetails?.content && (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width={SVGDetails?.width}
            height={SVGDetails?.height}
            version="1.1"
            viewBox={`0 0 ${SVGDetails?.width} ${SVGDetails?.height}`}
          >
            <defs>{convertHtmlToReact(defs)}</defs>
            {convertHtmlToReact(content)}
          </svg>
        )}
      </StyledImageTemplateWrapper>
    );
  })
);
